import { Link } from 'react-router-dom';

const contactChannels = [
  {
    icon: 'ri-phone-line',
    label: '電話諮詢',
    value: '04-2202-3211',
    sub: '週一至週六 09:00–18:00',
    href: 'tel:0422023211',
  },
  {
    icon: 'ri-chat-1-line',
    label: 'LINE 即時諮詢',
    value: '@xinlvdesign',
    sub: '24 小時可留言，1 工作天內回覆',
    href: '#',
  },
  {
    icon: 'ri-mail-send-line',
    label: 'Email 諮詢',
    value: 'newplusdesign2017@gmail.com',
    sub: '詳細需求說明，1 工作天內回信',
    href: 'mailto:newplusdesign2017@gmail.com',
  },
];

export default function FaqCta() {
  return (
    <section className="py-20 md:py-28 bg-[#1a1a1a]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20">

          {/* Left text */}
          <div className="lg:w-5/12">
            <p className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase mb-5">
              Still have questions?
            </p>
            <h2 className="font-bold text-white leading-[1.3] mb-6" style={{ fontSize: 'clamp(1.75rem, 3vw, 2.5rem)' }}>
              每個問題都值得<br />
              <span className="text-[#b8956a]">得到認真的回答</span>
            </h2>
            <p className="text-white/60 leading-[1.85] mb-10" style={{ fontSize: '1.0625rem' }}>
              我們相信，一次坦誠的對話勝過一千字的介紹。
              預約免費諮詢，讓我們直接針對你的空間與需求給出具體建議，沒有業務壓力，沒有強迫推銷。
            </p>

            <Link
              to="/contact"
              className="inline-flex items-center gap-3 px-8 py-4 bg-[#b8956a] text-white font-semibold rounded-full hover:bg-[#a07d58] transition-colors cursor-pointer whitespace-nowrap text-[1rem]"
            >
              <i className="ri-calendar-check-line text-lg"></i>
              預約免費諮詢
            </Link>

            <div className="mt-6 flex items-center gap-2 text-white/40 text-sm">
              <i className="ri-checkbox-circle-line text-[#b8956a]"></i>
              免費初次諮詢 · 無壓力 · 24 小時內回覆
            </div>
          </div>

          {/* Right: channels */}
          <div className="lg:w-7/12 grid grid-cols-1 sm:grid-cols-3 gap-4 w-full">
            {contactChannels.map((ch) => (
              <a
                key={ch.label}
                href={ch.href}
                className="flex flex-col gap-4 p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-[#b8956a]/40 transition-all duration-200 cursor-pointer group"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#b8956a]/20 group-hover:bg-[#b8956a]/30 transition-colors">
                  <i className={`${ch.icon} text-[#b8956a] text-xl`}></i>
                </div>
                <div>
                  <p className="text-white/50 text-xs font-medium tracking-wider uppercase mb-1">{ch.label}</p>
                  <p className="text-white font-semibold text-[0.9375rem] mb-1">{ch.value}</p>
                  <p className="text-white/40 text-xs leading-relaxed">{ch.sub}</p>
                </div>
                <div className="flex items-center gap-1 text-[#b8956a] text-xs font-medium mt-auto">
                  立即聯繫
                  <i className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-1 duration-200"></i>
                </div>
              </a>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}
